import { Thunk, thunk } from 'easy-peasy';

import { handleChristmasImages } from '../../store-helpers';

export interface ChristmasModel {
  get_photos: Thunk<ChristmasModel, unknown>;
}

export const christmasModel: ChristmasModel = {
  get_photos: thunk(async (_actions, params, { injections }) => {
    const { userService } = injections;
    return handleChristmasImages(await userService.getChristmasContestImages());
  }),
};
